module.exports = __webpack_public_path__ + "static/img/3.e1675e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/3.png
// module id = BrnH
// module chunks = 37